export const KANG_WIDGET_TOGGLE = 'kang_widget';
